import script from "./LinkShortener.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkShortener.vue?vue&type=script&setup=true&lang=js"

import "./LinkShortener.vue?vue&type=style&index=0&id=79f72f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f72f1a"]])

export default __exports__